import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Breadcrumbs,
  Link,
  Paper,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Business as OperationsIcon,
  Build as BuildIcon,
} from '@mui/icons-material';
import { useNavigationCore } from '../../../../core/router/navigation';
import { useMeCore } from '../../../../core/modules/me';
import { useAdjustmentsCore } from '../../../../core/modules/adjustments';
import { useCompanyCore } from '../../../../core/modules/company';
import {
  AdjustmentsList,
  AdjustmentsFilters,
  AdjustmentsDialog,
} from '../../../components/operations/adjustments';
import { ArticleForAdjustment } from '../../../../core/modules/adjustments/interfaces';

const Tools = () => {
  const { user } = useMeCore();
  const { goToWelcome } = useNavigationCore();
  const { companyId } = useCompanyCore();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedArticles, setSelectedArticles] = useState<ArticleForAdjustment[]>([]);
  const [initialType, setInitialType] = useState<'reduction' | 'container_origin_change'>('reduction');

  useEffect(() => {
    // Verificar permisos - solo supervisores pueden hacer ajustes
    if (
      !user ||
      (
        !user.privileges.superAdmin &&
        !user.privileges.writeReception
      )
    ) {
      goToWelcome();
    }
  }, [user, goToWelcome]);

  const handleOpenDialog = (articles: ArticleForAdjustment[], type: 'reduction' | 'container_origin_change' = 'reduction') => {
    setSelectedArticles(articles);
    setInitialType(type);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedArticles([]);
  };

  const handleSuccess = () => {
    // El diálogo ya refrescará los datos automáticamente
    setSelectedArticles([]);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
  

      {/* Header */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <BuildIcon color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h4" component="h1">
            Ajustes de Ubicaciones
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary">
          Gestiona los ajustes de ubicaciones de artículos. Selecciona los artículos que necesitan ajustes y modifica su ubicación, contenedor o cantidad.
        </Typography>
      </Paper>

      {/* Contenido principal */}
      <Box display="flex" flexDirection="column" gap={3}>
        {/* Filtros */}
        <AdjustmentsFilters />

        {/* Lista de artículos */}
        <AdjustmentsList onOpenAdjustmentDialog={handleOpenDialog} />
      </Box>

      {/* Diálogo de ajustes */}
      <AdjustmentsDialog
        open={dialogOpen}
        articles={selectedArticles}
        onClose={handleCloseDialog}
        onSuccess={handleSuccess}
        initialType={initialType}
      />
    </Container>
  );
};

export default Tools; 